var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass:
        "flex items-center w-full bg-black text-white text-left px-5 py-3 focus:outline-none hover:bg-black hover:bg-opacity-70 focus:bg-opacity-50 transition-opacity duration-300",
      attrs: { type: "button", "data-testid": "add-area-button" },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c("div", { staticClass: "w-5 h-5 mr-5" }, [_c("IconAdd")], 1),
      _vm._v("\n  Add another area\n"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }